<!--
 * @Author: cryi.liu
 * @Date: 2020-06-17 11:36:51
 * @LastEditTime: 2020-06-18 14:14:20
 * @Description: 阅卷主内容
-->
<template>
  <div class="mark-content">
    <mark-table :question-index="questionIndex" :data="data" />
    <mark-page :page="page" :total="total" @index-change="pageIndexChangeHandler" />
  </div>
</template>

<script>
import MarkTable from './MarkTable.vue';
import MarkPage from './MarkPage.vue';

export default {
  name: 'MarkContent',
  components: {
    MarkTable,
    MarkPage,
  },
  props: {
    questionIndex: { type: Number, required: true },
    data: { type: Array, required: true },
    page: { type: Object, required: true },
    total: { type: Number, required: true },
  },
  methods: {
    /**
     * 分页索引改变处理函数
     */
    pageIndexChangeHandler(index) {
      this.$emit('index-change', index);
    },
  },
};
</script>
